import { render, staticRenderFns } from "./NodeSummaryComponent.vue?vue&type=template&id=4f45f3dd&scoped=true&"
import script from "./NodeSummaryComponent.vue?vue&type=script&lang=ts&"
export * from "./NodeSummaryComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NodeSummaryComponent.vue?vue&type=style&index=0&id=4f45f3dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f45f3dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VTooltip})
